var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaletteIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "22px",
    viewBox: "0 0 37 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/graph/Palette") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "History-Log---Trailer-",
    transform: "translate(-225.000000, -608.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/Palette",
    transform: "translate(226.000000, 609.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "0.00109844055 7.2393107 0.00109844055 12.7620951 2.17089376 13.6607708 2.17089376 10.4862716 7.61731676 12.7330968 7.61731676 15.9075959 9.88907602 16.8353039 9.88907602 13.6607708 15.3209327 15.9075959 15.3209327 19.082129 17.5053285 19.9808048 17.5053285 14.4580543"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-2",
    stroke: "#000000",
    strokeWidth: 0.681290323,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.00109844055 7.2393107 0.00109844055 12.7620951 2.17089376 13.6607708 2.17089376 10.4862716 7.61731676 12.7330968 7.61731676 15.9075959 9.88907602 16.8353039 9.88907602 13.6607708 15.3209327 15.9075959 15.3209327 19.082129 17.5053285 19.9808048 17.5053285 14.4580543"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FFFFFF",
    points: "34.9949479 7.2393107 34.9949479 12.7620951 32.8251525 13.6607708 32.8251525 10.4862716 27.3932958 12.7330968 27.3932958 15.9075959 25.1069703 16.8353039 25.1069703 13.6607708 19.6751135 15.9075959 19.6751135 19.082129 17.5053182 19.9808048 17.5053182 14.4580543"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 0.015857)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.681290323
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    points: "34.9949479 7.22345331 34.9949479 12.7462377 32.8251525 13.6449134 32.8251525 10.4704143 27.3932958 12.7172394 27.3932958 15.8917385 25.1069703 16.8194465 25.1069703 13.6449134 19.6751135 15.8917385 19.6751135 19.0662716 17.5053182 19.9649474 17.5053182 14.4421969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5053114,0.0191714771 L34.994941,7.22344992",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5053114,0.0191714771 L0.00108138402,7.22344992",
    id: "Stroke-9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.5925775,1.29617317 L3.08834747,8.51491681",
    id: "Stroke-12",
    stroke: "#000000",
    strokeWidth: 0.681290323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1312753,2.73120543 L6.64164571,9.93544992",
    id: "Stroke-13",
    stroke: "#000000",
    strokeWidth: 0.681290323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3933026,4.10829202 L9.90363889,11.3270357",
    id: "Stroke-14",
    stroke: "#000000",
    strokeWidth: 0.681290323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2378173,5.68828183 L13.7335872,12.9070255",
    id: "Stroke-15",
    stroke: "#000000",
    strokeWidth: 0.681290323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73875487,12.196764 L2.170904,13.6607708",
    id: "Stroke-16",
    stroke: "#000000",
    strokeWidth: 0.681290323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4423606,15.3712733 L9.88907602,16.8352801",
    id: "Stroke-17",
    stroke: "#000000",
    strokeWidth: 0.681290323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.271885,12.196764 L32.8251355,13.6607708",
    id: "Stroke-18",
    stroke: "#000000",
    strokeWidth: 0.681290323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5537061,15.3712733 L25.1069566,16.8352801",
    id: "Stroke-19",
    stroke: "#000000",
    strokeWidth: 0.681290323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaletteIconBlack);
export default __webpack_public_path__ + "static/media/palette_icon_black.0242e001806692da11c7f205475cb8cb.svg";
export { ForwardRef as ReactComponent };